import { useLanguage } from '../contexts/LanguageContext';
import { appShellTranslator } from '../translations/appShell';
import React from 'react';

const DashboardFooter = () => {
  const { language } = useLanguage();
  const t = appShellTranslator(language);

  // Get build info
  const buildInfo = {
    version: 'v3.1.4',
    environment: 'Prod',
    buildDate: process.env.REACT_APP_BUILD_TIMESTAMP || new Date().toISOString()
  };

  const formatBuildDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString(language === 'es' ? 'es-ES' : 'en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: language !== 'es'
    });
  };

  return (
    <footer className="lexa-app-footer bg-white border-t border-slate-200 py-3 px-6">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        {/* Left side - Version and Environment */}
        <div className="flex items-center space-x-2 text-xs">
          <span className="text-slate-600 font-mono font-medium">
            {buildInfo.version}
          </span>
          <span className="text-slate-300">•</span>
          <span className="text-slate-600 font-medium">
            {buildInfo.environment}
          </span>
        </div>

        {/* Center - Build Date/Time */}
        <div className="text-xs text-slate-500 font-mono">
          {t("Built:")} {formatBuildDate(buildInfo.buildDate)}
        </div>

        {/* Right side - Text links */}
        <div className="flex items-center space-x-3 text-xs">
          <a
            href="/documentation"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              // Open documentation in new tab without user context
              e.preventDefault();
              const docsUrl = window.location.origin + '/documentation';
              window.open(docsUrl, '_blank', 'noopener,noreferrer');
            }}
            className="text-slate-500 hover:text-violet-700 transition-colors cursor-pointer"
          >
            {t("Docs")}
          </a>
          <span className="text-slate-300">•</span>
          <a
            href="mailto:support@lexa.run"
            className="text-slate-500 hover:text-violet-700 transition-colors"
          >
            {t("Help")}
          </a>
          <span className="text-slate-300">•</span>
          <button
            onClick={() => window.dispatchEvent(new CustomEvent('navigateToSupport'))}
            className="text-slate-500 hover:text-violet-700 transition-colors"
          >
            {t("Support Ticket")}
          </button>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;
